export default "__VITE_ASSET__tRwbo6pi__"